import React, { useEffect, useRef, useState } from 'react';
import {
  getCurrentPage,
  requestsSelector,
  setNextButtonEnabled,
  setRequestData,
} from '../../../redux/slicers/requestSlicer';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Type.module.scss';
import cx from 'classnames';
import { Form } from 'react-bootstrap';
import { apiUpdateRequest } from '../../../helpers/api';
import { useUserContext } from '../../../contexts/UserContext';

function Type() {
  const dispatch = useDispatch();
  const { isGuestUser } = useUserContext();
  const _requestSelector = useSelector(requestsSelector);
  const currentPage = useSelector(getCurrentPage);
  const [value, setValue] = useState(currentPage?.data);
  const dataRef = useRef(value);
  const requestIdRef = useRef(_requestSelector.currentRequestId);

  const TYPE_OPTIONS = {
    1: { name: 'NewModel' },
    2: {
      name: 'Existing',
      modelName: 'texture_included',
      child: {
        '2-1': 'Yes',
        '2-2': 'No',
        '2-3': "I Don't Know",
      },
    },
    3: {
      name: 'Variation',
      modelName: 'part_to_change',
      child: {
        '3-1': 'Structure',
        '3-2': 'Finish',
      },
    },
  };

  const setData = (data) => {
    // if (value?.parent === data?.parent && !data?.child) return;
    dataRef.current = data;
    dispatch(setRequestData(data));
    setValue(data);
  };

  useEffect(() => {
    setData(currentPage?.data);
    if (value?.parent) dispatch(setNextButtonEnabled(true));
    else dispatch(setNextButtonEnabled(false));

    return async () => {
      if (!dataRef.current.parent) return;
      const formData = new FormData();
      formData.append('request_model_type', TYPE_OPTIONS[dataRef.current.parent].name);

      // if (TYPE_OPTIONS[dataRef.current.parent].child)
      //   formData.append(
      //     TYPE_OPTIONS[dataRef.current.parent].modelName,
      //     TYPE_OPTIONS[dataRef.current.parent].child[dataRef.current.child]
      //   );

      if(isGuestUser()) {
        formData.append('is_internal_team', true);
      }

      await apiUpdateRequest(requestIdRef.current, formData);
    };
  }, []);

  const handleClick = (e) => {
    dispatch(setNextButtonEnabled(true));
    setData({ parent: e.target.id, subPages: [{ id: 1 }] });
  };

  const handle3dModelOptionClick = (e) => {
    dispatch(setNextButtonEnabled(true));

    if (e.target.id !== '2') {
      setData({
        parent: '2',
        child: e.target.id,
        subPages: [
          { id: 2, goNextTo: 1, showSkipButton: true },
          { id: 1, goBackTo: 2 },
        ],
      });
      // dispatch(setNextButtonEnabled(true));
    } else
      setData({
        parent: e.target.id,
        subPages: [
          { id: 2, goNextTo: 1, showSkipButton: true },
          { id: 1, goBackTo: 2 },
        ],
      });
  };

  const handleExistingModelOptionnClick = (e) => {
    dispatch(setNextButtonEnabled(true));

    const previousValue = Array.isArray(value?.child) ? value?.child : [];
    const finalValue = !previousValue?.includes(e.target.id)
      ? [...previousValue, e.target.id]
      : previousValue?.filter((_item) => _item !== e.target.id);

    if (e.target.id !== '3') {
      setData({
        parent: '3',
        child: finalValue,
        subPages: [{ id: 3 }],
      });

      // dispatch(setNextButtonEnabled(true));
    } else setData({ parent: e.target.id, subPages: [{ id: 3 }] });
  };

  useEffect(() => {
    requestIdRef.current = _requestSelector.currentRequestId;
  }, [_requestSelector.currentRequestId]);

  useEffect(() => {
    if (!currentPage?.data)
      dispatch(setNextButtonEnabled(false));
  }, [])

  return (
    <div
      className={cx('d-flex flex-column justify-content-start align-items-center', styles.wrapper)}>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <h2>Before we start do you have an existing 3d model?</h2>
        <span className={styles.mutedText}>What type of request you want</span>
      </div>

      <div>
        <Form>
          <Form.Check type="radio" id="1" className={styles.formWrapper}>
            <Form.Check.Input
              type="radio"
              name="type-group"
              onClick={handleClick}
              checked={value?.parent === '1'}
            />
            <Form.Label>
              <span className={styles.title}>New model from images</span>
              <span className={styles.mutedText}>
                Select type of request on basis of data you have.
              </span>
            </Form.Label>
          </Form.Check>
          <div>
            <Form.Check type="radio" id="2" className={styles.formWrapper}>
              <Form.Check.Input
                type="radio"
                name="type-group"
                onClick={handle3dModelOptionClick}
                checked={value?.parent === '2'}
              />
              <Form.Label>
                <span className={styles.title}>With existing 3d model</span>
                <span className={styles.mutedText}>
                  If you have a 3d file made by someone other than imagine.io and you want to
                  continue with it, please select this option.
                </span>
              </Form.Label>
            </Form.Check>
            {/* {value?.parent === '2' && (
              <div className="mx-5">
                <span className={styles.subtitle}>Are textures included in 3d file ?</span>
                <div className={styles.radioWrapper}>
                  <Form.Check type="radio" id="2-1">
                    <Form.Check.Input
                      type="radio"
                      name="type-group-2"
                      onClick={handle3dModelOptionClick}
                      checked={value?.child === '2-1'}
                    />
                    <Form.Label>
                      <span className={styles.title}>Yes</span>
                    </Form.Label>
                  </Form.Check>
                  <Form.Check type="radio" id="2-2">
                    <Form.Check.Input
                      type="radio"
                      name="type-group-2"
                      onClick={handle3dModelOptionClick}
                      checked={value?.child === '2-2'}
                    />
                    <Form.Label>
                      <span className={styles.title}>No</span>
                    </Form.Label>
                  </Form.Check>
                  <Form.Check type="radio" id="2-3">
                    <Form.Check.Input
                      type="radio"
                      name="type-group-2"
                      onClick={handle3dModelOptionClick}
                      checked={value?.child === '2-3'}
                    />
                    <Form.Label>
                      <span className={styles.title}>I don’t know</span>
                    </Form.Label>
                  </Form.Check>
                </div>
              </div>
            )} */}
          </div>
          <div>
            <Form.Check type="radio" id="3" className={styles.formWrapper}>
              <Form.Check.Input
                type="radio"
                name="type-group"
                onClick={handleExistingModelOptionnClick}
                checked={value?.parent === '3'}
              />
              <Form.Label>
                <span className={styles.title}>Existing model variations</span>
                <span className={styles.mutedText}>
                  If 3d model was created by imagine.io and you want to produce variations on it,
                  please select this option.
                </span>
              </Form.Label>
            </Form.Check>
            {/* {value?.parent === '3' && (
              <div className="mx-5">
                <span className={styles.subtitle}>Which part do you want to change ?</span>
                <div className={styles.radioWrapper}>
                  <Form.Check type="checkbox" id="3-1">
                    <Form.Check.Input
                      type="checkbox"
                      name="type-group-2"
                      onClick={handleExistingModelOptionnClick}
                      checked={value?.child?.includes('3-1')}
                    />
                    <Form.Label>
                      <span className={styles.title}>Structure</span>
                    </Form.Label>
                  </Form.Check>
                  <Form.Check type="checkbox" id="3-2">
                    <Form.Check.Input
                      type="checkbox"
                      name="type-group-2"
                      onClick={handleExistingModelOptionnClick}
                      checked={value?.child?.includes('3-2')}
                    />
                    <Form.Label>
                      <span className={styles.title}>Finish</span>
                    </Form.Label>
                  </Form.Check>
                </div>
              </div>
            )} */}
          </div>
        </Form>
      </div>
    </div>
  );
}

export default Type;
